import { Tooltip } from '@cian/ui-kit';
import * as React from 'react';

export function wrapWithTooltip(component: JSX.Element, tooltipContent: string): JSX.Element {
  return (
    <Tooltip title={tooltipContent} placement="right">
      {component}
    </Tooltip>
  );
}
